import React from 'react'
import { SelectGroupWrapper } from './style'

const SelectGroup = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <SelectGroupWrapper {...props} />
)

export default SelectGroup
